import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceCreateQuiz(params) {
  return await formDataRequest("quizzes/create", params);
}

export async function serviceUpdateQuiz(params) {
  return await formDataRequest("quizzes/update", params);
}

export async function serviceDeleteQuiz(params) {
  return await postRequest("quizzes/delete", params);
}

export async function serviceGetQuiz(params) {
  return await postRequest("quizzes", params);
}

export async function serviceGetQuizDetails(params) {
  return await postRequest("quizzes/detail", params);
}
export async function serviceUpdateQuizPriority(params) {
  return await postRequest("quizzes/update/priority", params);
}
